


































































































































import { Component, Prop, PropSync, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import {
  ITemplate,
  ITemplateChannel,
  ITemplateCategory
} from "@/models/templates";
import HasValidation from "@/mixins/HasValidation";
import { NotificationChannelCodes } from "@/data/enums/notifications";

@Component({
  components: {
    "tags-cloud-view": () =>
      import("@/components/app/global/tags/tagsCloudView.vue")
  }
})
export default class NotificationContent extends Mixins(
  RequestPromises,
  HasValidation
) {
  @PropSync("subject", { required: false })
  public subjectSynced!: string;

  @PropSync("body", { required: true })
  public bodySynced!: string;

  @Prop({ required: false, default: false })
  public isTranslation!: boolean;

  @Prop({ required: true })
  public processing!: string;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: true })
  public showSubject!: boolean;

  @Prop({ required: true })
  public template!: ITemplate;

  @Prop({ required: false })
  public channel!: ITemplateChannel;

  @Prop({ required: false })
  public category!: ITemplateCategory;

  @Prop({ required: true })
  public categories!: ITemplateCategory[];

  @Prop({ default: true })
  public showBodyArgsAndDesc!: boolean[];

  @Prop({
    default: () => ({
      mode: "twig",
      lineNumbers: false,
      styleActiveLine: false
    })
  })
  public codeMirrorOptions!: any[];

  @Prop({ default: null })
  public codeMirrorProps!: any;

  // Data
  public paramsSearch = "";
  public activeTab = 0;

  // Life-cycle methods

  public created() {
    this.$watch("categoryIds", () => (this.activeTab = 0));
  }

  public get categoryIds() {
    return this.categories.map(i => i.id);
  }

  public get filteredParams() {
    return this.$_.filter(this.categories[this.activeTab].params, param =>
      !this.$_.isEmpty(this.paramsSearch)
        ? this.$_.toUpper(param.field).includes(
            this.$_.toUpper(this.paramsSearch)
          )
        : true
    );
  }

  public get variableSuggestions() {
    const values: Array<{ displayText: string; text: string }> = [];
    this.$_.forEach(this.categories, category => {
      this.$_.forEach(category.params, param => {
        values.push({
          displayText: `${category.code}.${param?.field}`,
          text: `{{ ${category.code}.${param?.field} }}`
        });
      });
    });
    return values;
  }

  public onTabChange(index) {
    this.paramsSearch = "";
    this.$nextTick(() => {
      (this.$refs?.paramsSearch[index] as HTMLInputElement)?.focus();
    });
  }

  public copyDefaultSubject() {
    this.subjectSynced = this.template.subject;
  }

  public copyDefaultBody() {
    this.bodySynced = this.template.body;
  }

  public get isEmailChannel() {
    return (
      this.$_.get(this.channel, "code", "") === NotificationChannelCodes.EMAIL
    );
  }
}
